import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, LinearProgress } from "@mui/material";
import React from "react";
import { MainAppBar, type MainAppBarProps } from "#/features/appBar/ui/MainAppBar";
import { Footer } from "#/shared/ui/organisms/Footer";
import { PageScrollContainer, type PageScrollContainerProps } from "#/shared/ui/templates/PageScrollContainer";
export type MainLayoutProps = Omit<BoxProps, "onScroll"> & {
  children: React.ReactNode;
  isLoading?: boolean;
  headerPosition?: MainAppBarProps["position"];
  onScroll?: PageScrollContainerProps["onScroll"];
};
export const MainLayout: React.FC<MainLayoutProps> = t0 => {
  const $ = _c(24);
  let children;
  let isLoading;
  let onScroll;
  let restProps;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      isLoading,
      headerPosition: t1,
      onScroll,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isLoading;
    $[3] = onScroll;
    $[4] = restProps;
    $[5] = t1;
  } else {
    children = $[1];
    isLoading = $[2];
    onScroll = $[3];
    restProps = $[4];
    t1 = $[5];
  }
  const headerPosition = t1 === undefined ? "sticky" : t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "100vh"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: "100vh"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== headerPosition) {
    t4 = <MainAppBar position={headerPosition} />;
    $[8] = headerPosition;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minHeight: "85vh"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== isLoading) {
    t6 = isLoading ? <LinearProgress variant="indeterminate" /> : children;
    $[11] = children;
    $[12] = isLoading;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Box component="main" sx={t5}>{t6}</Box>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Footer />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== restProps || $[18] !== t4 || $[19] !== t7) {
    t9 = <Box sx={t3} {...restProps}>{t4}{t7}{t8}</Box>;
    $[17] = restProps;
    $[18] = t4;
    $[19] = t7;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onScroll || $[22] !== t9) {
    t10 = <PageScrollContainer isPage={true} style={t2} onScroll={onScroll}>{t9}</PageScrollContainer>;
    $[21] = onScroll;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};